import React from 'react';
import { Col, Input, Label } from 'reactstrap';
import { Select } from '@mantine/core';

const ResponsableCargoFields = ({
	validation,
	personSelectData,
	positionSelectData,
	isNewPerson,
	cargoDisplayName,
	setCreatedPersons,
	setCreatedPositions,
}) => {
	const { values, errors, submitCount, setFieldValue } = validation;

	return (
		<>
			<Col lg={4} className='mb-3'>
				<Label className='form-label'>
					Responsable <span className='text-danger'>*</span>
				</Label>
				<Select
					data={personSelectData}
					value={values.responsable_id}
					onChange={value => setFieldValue('responsable_id', value || '')}
					placeholder='Seleccione o ingrese nombre'
					searchable
					clearable
					creatable
					getCreateLabel={query => `+ Agregar "${query}"`}
					onCreate={query => {
						const item = { value: query, label: query };
						setCreatedPersons(prev => [...prev, item]);
						setFieldValue('responsable_id', query);
						return item;
					}}
					error={submitCount > 0 && errors.responsable_id ? errors.responsable_id : null}
				/>
			</Col>

			<Col lg={4} className='mb-3'>
				<Label className='form-label'>Cargo</Label>
				{isNewPerson ? (
					<Select
						data={positionSelectData}
						value={values.management_position_id}
						onChange={value => setFieldValue('management_position_id', value || '')}
						placeholder='Seleccione o ingrese cargo'
						searchable
						clearable
						creatable
						getCreateLabel={query => `+ Agregar "${query}"`}
						onCreate={query => {
							const item = { value: query, label: query };
							setCreatedPositions(prev => [...prev, item]);
							setFieldValue('management_position_id', query);
							return item;
						}}
					/>
				) : (
					<Input
						className='form-control'
						type='text'
						value={cargoDisplayName}
						disabled
						readOnly
					/>
				)}
			</Col>
		</>
	);
};

export default ResponsableCargoFields;
